import React from 'react'
import { navigate } from '@reach/router'
import { object, string } from 'prop-types'
import { PAGAMENTO_CARTAO, PAGAMENTO_BOLETO, PAGAMENTO_PIX } from '../../../../constants'
import { TITULO_CARD, DESCRICAO_SEM_METODO_PAGAMENTO } from './constantsCardPagamento'
import { useGlobal } from '../../../../contexts/GlobalContext'
import Card from '@taglivros/oef_componentes/build/components/card'
import CartaoCredito from '../../../../components/CartaoCredito/CartaoCredito'
import { ReactComponent as PixIcon } from '../../../../assets/imagens/pix.svg'
import { Descricao, Titulo, PaymentMethodPix } from './styles'

const CardPagamento = ( { dados, metodoPagamento } ) => {
  const { modalidadeURL } = useGlobal()

  const handleClick = () => {
    navigate( `${modalidadeURL}/pagamento` )
  }

  const metodoPagamentoElement = () => {
    if ( !metodoPagamento || !dados ) {
      return null
    }
    if ( metodoPagamento === PAGAMENTO_CARTAO ) {
      return (
        <CartaoCredito
          cartao={ dados }
          margin="20px 0 0"
          resumido={ true }
        />
      )
    }
    if ( metodoPagamento === PAGAMENTO_BOLETO ) {
      return (
        <Descricao>
          <p>
            { PAGAMENTO_BOLETO }
          </p>
        </Descricao>
      )
    }
    if ( metodoPagamento === PAGAMENTO_PIX ) {
      return (
        <Descricao>
          <PaymentMethodPix>
            <PixIcon />

            { PAGAMENTO_PIX }
          </PaymentMethodPix>
        </Descricao>
      )
    }
    return (
      <Descricao>
        { DESCRICAO_SEM_METODO_PAGAMENTO }
      </Descricao>
    )
  }

  return (
    <Card
      className="card"
      largura="100%"
      margin="0 0 30px 0"
    >
      <Titulo>
        { TITULO_CARD }

        <span onClick={ handleClick }>Ver mais</span>
      </Titulo>

      { metodoPagamentoElement() }

    </Card>
  )
}

CardPagamento.propTypes = {
  'dados': object,
  'metodoPagamento': string.isRequired
}

CardPagamento.defaultProps = {
  'dados': null
}

export default CardPagamento
